import * as React from 'react';
import {
  SliderItem,
  GetTrackProps
} from 'react-compound-slider';

// *******************************************************
// TRACK COMPONENT
// *******************************************************
interface TrackProps {
  source: SliderItem;
  target: SliderItem;
  getTrackProps: GetTrackProps;
}

export const Track: React.SFC<TrackProps> = ({
  source,
  target,
  getTrackProps
}) => (
  <div className='tracks-percentage-wrap'>
    <div className='tracks-wrap'>
      <div
        className='track-left'
        style={{
          width: `${target.percent - source.percent}%`
        }}
        {...getTrackProps()}
      />
      <div
        className='track-right'
        style={{
          width: `${100 - source.percent - target.percent}%`
        }}
        {...getTrackProps()}
        />
    </div>
  </div>
);

export const DisabledTrack: React.SFC<TrackProps> = ({
  source,
  target,
  getTrackProps
}) => (
  <div className='tracks-percentage-wrap'>
    <div className='tracks-wrap'>
      <div
        className='track-left'
        style={{
          width: `${target.percent - source.percent}%`
        }}
      />
      <div
        className='track-right'
        style={{
          width: `${100 - source.percent - target.percent}%`
        }}
        />
    </div>
  </div>
);